// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("logolarge.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.home-page {
  padding-top: 3rem;
  text-align: center;

  button {
    margin-top: 1vh;
    color: white;
    background-color: #0091ea;
    padding: 2%;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-shadow: 1px 1px 2px black;
    border: 1px solid #0091ea;
  }
  
  button:hover {
    background-color: #00aff0;
  }
}

.get-started-automating {
  padding-top: 2vh;
  padding-bottom: 5vh;
}

.contact-container {
  display: flex;
  padding-top: 3vh;
  justify-content: center;
}

.contact-form {
  background-color: white;
  padding: 2vw;
  width:100%;
  margin-top: 10vh;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  h1 {
    font-size: 2rem;
  }

  label {
    font-size: 1rem;
  }
  button {
    color: white;
    background-color: #0091ea;
    padding: 2%;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-shadow: 1px 1px 2px black;
    border: 1px solid #0091ea;
  }

  input {
    border-radius: 10px;
    padding: 1%;
    margin: 2%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #0091ea;
    width: 70%;
  }

  input:focus {
    outline: none !important;
  }

  textarea {
    border-radius: 10px;
    padding: 1%;
    margin: 2%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #0091ea;
    width: 70%;
  }

  textarea:focus {
    outline: none !important;
  }

  
}

.about-page {
  padding-top: 3rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  height: auto;
} 

.about-page-header {
  flex: 2 1;
}

.whoweare-image-container {
  width: 100%;
  height: auto;
}

.whoweare-text {
  bottom: 0;
  color: #00aff0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  h1 {
    color: grey;
    text-align: left;
    text-decoration: underline;
    text-decoration-color: #00aff0;
    font-size: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  p {
    color: black;
    font-size: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.about-page-second-box {
  display: flex;
  flex-direction: column;
}

.about-page-second-box-box {
  padding-top: 6rem;
  padding-bottom: 6rem;
  padding-left: 20vw;
  background-color: #00aff0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  h1 {
    color: white;
    text-align: left;
    text-decoration: underline;
    text-underline-offset: 3%;
    text-decoration-color: white;
    font-size: 2rem;
    margin: 1rem;
  }

  p {
    color: white;
    font-size: 1.5rem;
    margin: 1rem;
  }

  button {
    border: none;
    padding: 1rem;
    margin-right: 6rem;
    margin-bottom: 2rem;
    border-radius: 1rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 1rem;
  }

  button:hover {
    color: #00aff0;
  }
}

.about-page-second-second-box {
  padding-top: 6rem;
  padding-bottom: 6rem;
  padding-right: 20vw;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: right;
  
  h1 {
    color: grey;
    text-align: right;
    text-decoration: underline;
    text-underline-offset: 3%;
    text-decoration-color: #00aff0;
    font-size: 2rem;
  }

  p {
    color: black;
    font-size: 1.5rem
  }

  button {
    border: none;
    padding: 1rem;
    margin-left: 6rem;
    margin-bottom: 2rem;
    border-radius: 1rem;
    background-color: #00aff0;
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  button:hover {
    background-color: #0091ea;
  }
}

.about-page-twotonebox-container {
  display: flex;
  flex-direction: row;
}

.about-page-users-box-light-blue {
  width: 20vw;
  height: 40vh;
  background-color: #a7e7ff;

}

.about-page-users-box-dark-blue {
  width: 80vw;
  height: 45vh;
  background-color: #00aff0;

  h1 {
    color: white;
    text-align: left;
    text-decoration: underline;
    text-underline-offset: 3%;
    text-decoration-color: white;
    font-size: 2vw;
    padding-left: 5rem;
  }

  p {
    color: white;
    font-size: 1vw;
    padding-left: 5rem;
  }
}

.about-page-white-box {
  height: 10vh;
}

.about-page-white-box-users {
  height: 33vh;
}

.userbox {
  position: relative;
  width: 100%;
}



.about-page-support-twotonebox-container {
  display: flex;
  flex-direction: row;
  height: auto;
}

.about-page-users-support-box-light-blue {
  width: 85vw;
  height: auto;
  background-color: #a7e7ff;
 
  h1 {
    margin-top: 5%;
    color: grey;
    text-align: left;
    text-decoration: underline;
    text-underline-offset: 3%;
    text-decoration-color: #00aff0;
    font-size: 2rem;
    padding-left: 5rem;
    margin-right: 1rem;
    margin-left: 1rem;
  }

  p {
    color: black;
    font-size: 1.5rem;
    padding-left: 5rem;
    margin-right: 1rem;
    margin-left: 1rem;
  }

  button {
    color: black;
    background-color: white;
    padding: 1rem;
    margin-left: 6rem;
    margin-bottom: 2rem;
    border-radius: 1rem;
    border: none;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  button:hover {
    color: #00aff0;
  }
}

.about-page-users-support-box-dark-blue {
  width: 15vw;
  height: auto;
  background-color: #00aff0;
}

.about-page-pb-parent{
  display: flex;
  /* justify-content: space-between; */
  height: 15vh;
  width: 100%;
}

.about-page-post-boxes {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 3vw;
  
  position: absolute;
  top: 16vh; 
  left: 30vh;  
  padding: 0 auto;
  transform: translate(0%, 1%);
  color: #00aff0; 
}

.about-page-post-box {
  flex: 3 1;
  width: 20vw;
  height: 10vh;
}

.login-register-anchor {
  a {
    color: white;
  }

  a:hover {
    color:#0091ea
  }
}

.registration-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: white;
}

.footer-container {
  padding-top: 3vh;
  display: flex;
  flex-direction: row;
  gap: 2%;
  background-color: #00aff0;
  overflow: hidden;
  width: 100%;
  box-shadow: 0 4px 8px black;
  border-top: 1vh solid white;
  height: 3rem;
  z-index: 1000;
  padding-left: 4vw;
}

.pp-title-container {
  padding-top: 4%;
  background-color: white;
  height: 10%;
  text-align: center;
  margin-bottom: 20px;
}

.pp-title-container h1 {
  padding-top: 1vh;
  padding-left: 30vw;
}

.pp-tos-container {
  background-color: white;
  height: 10%;
}

.pp-tos-container h1 {
  padding-left: 30vw;
  text-align: left;
}

.missionHeader {
  padding-top: 5vh;
  padding-bottom: 1vh;
  text-decoration: underline;
}

.constact-support-container {
  padding-top: 3vh;
  display: flex;
  flex-direction: row;
  font-family: Arial, sans-serif;
  color: #333;
  height: 100%;
}


.pp-policy-container {
  padding-top: 3vh;
  display: flex;
  flex-direction: row;
  font-family: Arial, sans-serif;
  color: #333;
  height: auto; /* Adjust height to auto so it expands based on content */
}

.pp-policy-container2 {
  border-top: 1px solid white;
  display: flex;
  flex-direction: row;
  font-family: Arial, sans-serif;
  color: #333;
  height: auto; /* Adjust height to auto so it expands based on content */
}

.contact-support-left {
  background-color: #00aff0;
  width: 15vw;
  height: 100vh; /* Ensures the left panel is at least as tall as the viewport */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.contact-support-right {
  background-color: #0091ea;
  width: 85vw;
  padding-left: 10vw;
  padding-right: 10vw;
  height: 100vh; /* Ensures the right panel is at least as tall as the viewport */
  box-sizing: border-box;
}

.pp-policy-container-left {
  background-color: #00aff0;
  width: 15vw;
  min-height: 100vh; /* Ensures the left panel is at least as tall as the viewport */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding-top: 4vh;
}

.pp-policy-container-right {
  background-color: #0091ea;
  width: 85vw;
  padding-left: 10vw;
  padding-top: 4vh;
  padding-right: 10vw;
  padding-bottom: 4vh; 
  min-height: 100vh; /* Ensures the right panel is at least as tall as the viewport */
  box-sizing: border-box;
}

.privacy-policy-text-container {
  color: white; /* Adjust text color to ensure readability */
  line-height: 1.6; /* Improve text readability */
}

.policy-heading {
  font-size: 1.5rem;
  margin-top: 20px;
  margin-bottom: 10px;
  color: white;
}

.policy-subheading {
  font-size: 1.25rem;
  margin-top: 20px;
  margin-bottom: 10px;
  color: white;
}

.policy-text {
  font-size: 1rem;
  margin-bottom: 10px;
  text-align: justify;
  color: white;
}


.registration-box {
  width: 90%;
  max-width: 400px;
  padding: 3rem;
  background-color: #00aff0;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  color: white;
  margin: 1rem;
  h1 {
    text-shadow: 1px 1px 2px black;
  }

  button {
    margin-top: 10%;
    color: white;
    background-color: #0091ea;
    padding: 2%;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-shadow: 1px 1px 2px black;
    border: 1px solid #0091ea;
  }
}

.registration-input-container {
  input {
    border-radius: 10px;
    padding: 4%;
    margin: 2%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #0091ea;
  }

  input:focus {
    outline: none !important;
  }
}

.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: white;
}

.login-box {
  width: 90%;
  max-width: 400px;
  padding: 3rem;
  background-color: #00aff0;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  color: white;
  margin: 1rem;
  h1 {
    text-shadow: 1px 1px 2px black;
  }

  button {
    margin-top: 10%;
    color: white;
    background-color: #0091ea;
    padding: 2%;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-shadow: 1px 1px 2px black;
    border: 1px solid #0091ea;
  }
}

.login-input-container {
  input {
    border-radius: 10px;
    padding: 4%;
    margin: 2%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #0091ea;
  }

  input:focus {
    outline: none !important;
  }
}

.App-logo {
  max-height: 20vmin;
  pointer-events: none;
}

/* @media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: combinedAnimation 5s linear infinite;
  }
} */

.App-logo {
  border-radius: 5%;
  box-shadow: 5px 5px black;
}

@keyframes combinedAnimation {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(1.2);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}

.Login-header {
  background-color: #282c34;
  min-height: 25vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
  padding: 4%;
}

.App-header {
  background-color: #00aff0;
  min-height: 20vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2vw;
  color: white;
  padding-top: 2%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  
  h2 {  
    text-shadow: 1px 1px 2px black;
  }
}

.home-page-body {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  text-align: center;
  padding-bottom: 2vh;
  p {
    font-size: 1.5rem;
  }
}

.schedule-job-header {
  background-color: #282c34;
  min-height: 15;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
  padding-top: 6rem;
}

.who-this-is-for-container {
  text-align: left;
  margin: 3%;
}

.two-tone-feature-container {
  display: flex;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.small-feature-darkblue {
  background-color: #0091ea;
  height: auto;
  width: 15vw;
  padding-bottom: 2vh;
}

.big-feature-blue {
  background-color: #00aff0;
  /* height: auto; */
  height: 40vh;
  width: 85vw;
  display: flex;
  flex-direction: column;
  /* justify-content: left; */
  vertical-align: middle;
  align-items: center;
  /* text-align: left; */

  h1 {
    margin-left: 3vw;
    color: white;
    font-size: 2rem;
    margin-right: 3vw;
  }
  
  p {
    margin-left: 3vw;
    color: white;
    font-size: 1.75rem;
    margin-right: 3vw;
  }
  padding-bottom: 2vh;
}


.big-feature-darkblue {
  background-color: #0091ea;
  /* height: auto; */
  height: 35vh;
  width: 85vw;
  display: flex;
  
  display: flex;
  flex-direction: column;
  text-align: right;
  h1 {
    margin-right: 3vw;
    color: white;
    font-size: 2rem;
    margin-left: 3vw;
  }

  p {
    color: white;
    margin-right: 3vw;
    font-size: 1rem;
    margin-left: 3vw;
  }

  padding-bottom: 2vh;
}

.tos-priv-homescreen {
  margin-top: 3rem;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 1rem;
}

.small-feature-blue {
  background-color: #00aff0;
  height: auto;
  width: 15vw;
}

.features-white-box {
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0091ea;
  display: flex;
  flex-direction: column;

  padding-top: 3rem;
  padding-bottom: 3rem;

  h1 {
    font-size: 2rem;
  }

  p {
    font-size: 1.75rem;
    padding-left: 2vw;
    padding-right: 2vw;
  }

  /* padding-bottom: 2vh; */
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes scaleAnimation {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
}


/* CSS styles */
.modal-container {
  position: relative;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  backdrop-filter: blur(5px); /* Blur effect */
  z-index: 999; /* Ensure backdrop is above other content */
}

/* Style the modal */
.UpdateImageDataModal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 1000;
  box-shadow: 0 0 10px #00aff0;
  max-height: 75vh; /* Set maximum height to 75% of viewport height */
  overflow-y: auto; /* Enable vertical scrolling when content exceeds max-height */
  width: 75%; /* Set width to 75% of viewport width */
  max-width: 500px; /* Set maximum width */
}

.jobsdetailsmodal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 1000;
  box-shadow: 0 0 10px #00aff0;
  max-height: 75vh; /* Set maximum height to 75% of viewport height */
  overflow-y: auto; /* Enable vertical scrolling when content exceeds max-height */
  width: 75%; /* Set width to 75% of viewport width */
  max-width: 500px; /* Set maximum width */
  text-align: center;
}

.image-box {
  /* Add other styles */
  border: 1px solid transparent; /* Initially set to transparent */
}

.image-box.selected {
  border-color: lightgrey; /* Change border color when selected */
}

.image-name {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 5px;
  margin: 0;
}


.upload-box-container {
  /* margin-top: 3px; */
  /* border: 2px solid #ccc; */
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #282c34;
  color: white;
  padding-top: 4rem;
}

.upload-picture-box {
  background-color: #282c34;
  color: white;
  padding-bottom: 1rem;
}

.upload-section {
  padding: 10px;
}

.upload-section label {
  margin-right: 10px;
  text-decoration-color: white;
}

.upload-section button {
  margin-top: 10px;
  text-decoration-color: white;
}

.upload-color {
  color: white;
  text-align: center;
  background-color: #282c34;
}

.dmjob-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
}

.dmjobModal {
  height: 60vh;
  margin-top: 2rem;
  background-color: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 10px #00aff0;
  z-index: 1000;
  align-items: center;
  margin: 1rem;
  overflow-y: scroll;
  min-width: 90vw;
}

/* CSS styles for SetScheduleModal */
.SetScheduleModal-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 70%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
}

.SetScheduleModal-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.setScheduleModalHeader {
  -webkit-text-decoration: underline #00aff0;
          text-decoration: underline #00aff0;
  text-underline-offset: .5rem;
}

.SetScheduleModal {
  height: 60vh;
  margin-top: 2rem;
  background-color: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 10px #00aff0;
  z-index: 1000;
  align-items: center;
  margin: 1rem;
  overflow-y: scroll;
  min-width: 90vw;
}

.postJobModal {
  height: 60vh;
  min-width: 90vw;
  margin-top: 2rem;
  background-color: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 10px #00aff0;
  z-index: 1000;
  align-items: center;
  margin: 1rem;
  overflow-y: scroll;
}

.loginmodal {
  background-color: white;
  padding: 3rem;
  border-radius: 1rem;
  box-shadow: 0 0 10px #00aff0;
  z-index: 1000; /* Ensure modal appears above backdrop */
  align-items: center;
  margin: 1rem;

  button {
    /* margin-left: 1rem; */
    padding: 1rem;
    background-color: #0091ea;
    border-radius: 1rem;
    border: 0;
    color: white;
  }

  button:hover {
    background-color: #00aff0;
  }
}

.selected-day {
  background-color: lightgrey;
  color: black; /* Adjust text color as needed */
}

.selected-day:hover {
  background-color: darkgrey; /* Change color on hover if desired */
}

.aiInputs {
  margin: 1rem;
  font-size: 1.25rem;
  -webkit-text-decoration: underline #00aff0;
          text-decoration: underline #00aff0;
  text-underline-offset: .25rem;
  
  label {
    margin-bottom: 1rem;
  }
}

/* .aibox {
  margin-top: 1rem;
} */
 .ailabel {
  display: flex;
 }

 .aitext {
  display: flex;
  flex-wrap: wrap;
 }

.aiInputContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modalSelect {
  padding: .5rem;;
  margin: .5rem;
  border-radius: 1rem;
  background-color: #00aff0;
  color: white;
  border: 0;
}

.modalSelect:hover {
  padding: .5rem;;
  margin: .5rem;
  border-radius: 1rem;
  background-color: #0091ea;
  color: white;
  border: 0;
}

.disabledButton {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.input-group {
  font-size: 1.25rem;
  -webkit-text-decoration: underline #00aff0;
          text-decoration: underline #00aff0;
  text-underline-offset: .25rem;
}


/* This is for the time selectors */
.input-group > div {
  display: flex;
  justify-content: center; 
  align-items: center; 
  gap: 10px;
}

.dayselect-input {
  
  button {
    margin: 1rem;
    padding: 1rem;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    /* background-color: #00aff0; */
    text-align: center; 
    color: white;
    border: 0;
  }

  /* button:hover {
    background-color: red;
  } */
}

/* Style for the button */
.input-group button {
  margin: 1rem;
  padding: 1rem;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  background-color: #00aff0; 
  text-align: center; 
  color: white;
  border: 0;
}

.subredditSelect button {
  margin: 1rem;
  padding: 1rem;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  background-color: #00aff0; 
  text-align: center; 
  color: white;
  border: 0;
}

.input-group button:hover {
  margin: 1rem;
  padding: 1rem;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  background-color: #0091ea; 
  text-align: center; 
  color: white;
  border: 0;
}

.unselected-day {
  background-color: #00aff0; 
  /* color: #ffffff;  */
}

.selected-day {
  background-color: #146aa0; 
  
 
}



.navbar {
  background-color: #00aff0; /* Background color of the navbar */
  overflow: hidden; /* Ensure contents don't overflow */
  border-bottom: 2px solid #0091ea;
  position: fixed;
  top: 0;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-shadow: 1px 1px 2px black;
  height: 3rem;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
}

.navbar ul {
  list-style-type: none; /* Remove bullet points from the list */
  padding: 0; /* Remove default padding */
  margin: 0; /* Remove default margin */
  display: flex; /* Use flexbox for layout */
  align-items: center; /* Center items vertically */
}

.navbar li {
  flex: 1 1; /* Make list items flexible */
  text-align: center; /* Center-align text */
}

.navbar li a {
  display: block; /* Display the links as block elements */
  color: white; /* Text color */
  text-align: center; /* Center-align text */
  padding: 0.5rem 1rem; /* Padding around the text */
  text-decoration: none; /* Remove underline from links */
  font-size: 1.2vw; /* Responsive font size */
  white-space: nowrap; /* Prevent text wrapping */
}

.navbar li a:hover {
  background-color: #ddd; /* Background color on hover */
  color: black; /* Text color on hover */
}

.left-section, .right-section {
  display: flex; /* Use flexbox for layout */
  align-items: center; /* Center items vertically */
}

.right-section {
  justify-content: flex-end; /* Align right-section items to the right */
}

/* Media queries to adjust font-size for smaller screens */
@media (max-width: 1024px) {
  .navbar li a {
    font-size: 1.4vw; /* Slightly increase the font size for medium screens */
  }
}

@media (max-width: 768px) {
  .navbar li a {
    font-size: 1.6vw; /* Increase the font size for smaller screens */
  }
}

@media (max-width: 480px) {
  .navbar li a {
    font-size: 2.5vw; /* Further increase the font size for very small screens */
  }
}


.subreddit-selector {
  position: relative; /* Needed to position the dropdown absolutely within the container */
}

.subreddit-selector .dropdown-menu {
  position: absolute;
  left: 50%; /* Centers the dropdown */
  top: 100%; /* Moves the dropdown right below the button */
  transform: translateX(-50%); /* Shifts the dropdown back by half its width */
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  width: auto; /* Adjusts width to content */
  min-width: 300px; /* Minimum width, adjust based on your preference */
  max-width: 90vw; /* Prevents the dropdown from being too wide */
  max-height: 15vh; /* Adjust based on your preference */
  overflow-y: auto; /* Enables vertical scrolling */
  z-index: 1;
}

.subreddit-selector .dropdown-menu .grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* Creates four columns */
  gap: 10px; /* Space between grid items */
}

.subreddit-selector .dropdown-menu .grid-item label {
  cursor: pointer;
  display: flex; /* Ensures the label contents are in line */
  align-items: center; /* Aligns the checkbox and text vertically */
}

.subreddit-selector .dropdown-menu .grid-item label span {
  margin-left: 5px; /* Provides space between the checkbox and text */
  display: block; /* Allows text to use the full available space */
  overflow: visible; /* Shows all content */
}

.jobs-table {
  display: flex;
  justify-content: center;
  height: auto; 
  margin-top: 5%;
  margin-bottom: 5%;

  table {
    /* padding-left: 2rem;
    padding-right: 2rem; */
    border-collapse: collapse;
    width: 50%; /* Adjust the width as needed */
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 1rem;
    text-align: left;
  }
  
  th {
    background-color: #f2f2f2;
    font-weight: bold;
  }
  
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  tr:hover {
    background-color: #ddd;
  }
}

.jobs-container {
  display: flex;
  flex-direction: column;
}

.jobs-header-container {
  padding-top: 10vh;
  text-align: center;

}

.active-job-box {
  background-color: #0091ea;
  margin: 0 2rem 1rem;
  padding: 0.5rem;
  min-height: 4rem;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.1);
}



.active-job-box:hover {
  background-color: #00aff0;
}

.job-details {
  display: flex;
  justify-content: space-between; /* Spread items across the line */
  align-items: center; 
  height: 100%;
  gap: 1rem; /* Space between items */
  flex-wrap: wrap; /* Allow wrapping to new lines on smaller screens */
  padding: 1rem;
}

.job-details p {
  font-size: 1rem;
  margin: 0;
  line-height: 1.2;
  word-wrap: break-word;
  flex: 1 1; /* Allow text to take available space */
  color: white;
}

.canceljobbuttonbox button {
  font-size: 1rem;
  padding: 0.4rem 0.8rem;
  border: none;
  background-color: #ff3b30;
  color: white;
  cursor: pointer;
  border-radius: 0.3rem;
  flex-shrink: 0; /* Prevent the button from shrinking */
}

.canceljobbuttonbox {
  display: flex;
  justify-content: flex-end;
}

/* Adjust for smaller screens */
@media (max-width: 768px) {
  .active-job-box {
    margin: 0 1rem 1rem;
    padding: 0.8rem;
  }

  .job-details {
    flex-direction: column; /* Stack items vertically */
    align-items: flex-start; /* Align items to the left */
  }

  .job-details p,
  .job-details button {
    font-size: 0.9rem;
  }

  .job-details button {
    margin-top: 0.5rem; /* Add some space above the button */
    align-self: center; /* Center the button on smaller screens */
  }
}

@media (max-width: 480px) {
  .active-job-box {
    margin: 0 0.5rem 1rem;
    padding: 1rem;
  }

  .job-details p,
  .job-details button {
    font-size: 0.85rem;
  }

  .job-details button {
    padding: 0.3rem 0.7rem;
  }
}

.active-jobs-container {
  padding: 1rem 0;
}


.photo-post-job-container {
  p{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.jobbox {
  margin-bottom: 3rem;
  text-align: center;
  
  p{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  button {
    color: white;
    background-color: #0091ea;
    border: 0;
    border-radius: 1rem;
    padding: 1rem;
    margin-top: .25rem;
  }

  button:hover {
    background-color: #00aff0;
  }

}

.updateImageModalButtons {
  button {
    margin-top: 1vh;
    color: white;
    background-color: #0091ea;
    padding: 2%;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-shadow: 1px 1px 2px black;
    border: 1px solid #0091ea;
    margin: 1rem;
  }
  
  button:hover {
    background-color: #00aff0;
  }
}


.ReactTags__tagInputField {
  width: 100%;
  border-radius: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: .15rem;
  border: 1px solid black;
  margin-bottom: 1rem;
}

.ReactTags__remove {
  background-color: #00aff0;
  border: 0;
  border-radius: 1rem;
  text-align: center;
  margin: .25rem;

  svg {
    display: block;
    margin: auto;
  }
}

.authorize-box {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    margin-left: 1rem;
    background-color: #0091ea;
    border-radius: .25rem;
    border: 0;
    color: white;
  }

  button:hover {
    background-color: #00aff0;
  }
}
 
.authorized-accounts-box {
  border: .25rem solid #00aff0;
  height: 8.5rem;
  margin: 1rem;
  display: flex;
  flex-direction: row;
  overflow: auto;
  border-radius: 1rem;
}

.authorize-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.accountbox {
  border: 1px solid black;
  height: 4rem;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  margin: 1rem;
  border-radius: 1rem;
  background-color: #0091ea;
  border: 0;
  color: white;
}

.accountbox:hover {
  background-color: #00aff0;
}

.password-validations p {
  margin: 0;
  padding: 5px 0;
  font-size: 14px;
}

.password-validations .valid {
  color: green;
}

.password-validations .invalid {
  color: red;
}

.login-error-message {
  color: red;
}

.username-validations p {
  margin: 0;
  padding: 5px 0;
  font-size: 14px;
}

.username-validations .valid {
  color: green;
}

.username-validations .invalid {
  color: red;
}

.registerbutton button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

.payment-page-container {
  display: flex;
  justify-content: center; 
  align-items: center;   
  height: 100vh;         
}

.payment-box {
  display: flex;
  justify-content: center; 
  align-items: center;   
  width: 100%;            
  height: 100%;           
}

.proSuccessContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
}

.proSuccessScreen {
  padding: 2rem;
  color: #00aff0;
  
  a {
    color: #0091ea;
  }
}

.youHavePremium {
  text-align: center;

  button {
    padding: 1rem;
    background-color: #0091ea;
    border-radius: 1rem;
    border: 0;
    color: white;
  }

  button:hover {
    background-color: #00aff0;
  }
}

.limitmodalLandingscreen {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,wCAAwC;IACxC,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;;EAExC;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,wCAAwC;IACxC,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,wCAAwC;IACxC,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,wCAAwC;IACxC,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;;AAGF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,yDAAsC;EACtC,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B;IACE,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;;EAExC;IACE,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,iBAAiB;;EAEjB;IACE,WAAW;IACX,iBAAiB;IACjB,0BAA0B;IAC1B,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ;EACF;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,wCAAwC;EAC1C;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;;EAEzB;IACE,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;;EAEzB;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;EAC1C;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;;EAER,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY,EAAE,yDAAyD;AACzE;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY,EAAE,yDAAyD;AACzE;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa,EAAE,+DAA+D;EAC9E,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa,EAAE,gEAAgE;EAC/E,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB,EAAE,+DAA+D;EAClF,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB,EAAE,gEAAgE;EACnF,sBAAsB;AACxB;;AAEA;EACE,YAAY,EAAE,4CAA4C;EAC1D,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,wCAAwC;IACxC,8BAA8B;IAC9B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,wCAAwC;IACxC,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,wCAAwC;IACxC,8BAA8B;IAC9B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,wCAAwC;IACxC,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;GAIG;;AAEH;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,wCAAwC;;EAExC;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;;EAEtB;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB;IACE,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;;EAEtB,iBAAiB;EACjB,oBAAoB;;EAEpB;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;;AAGA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,gCAAgC;EACtE,0BAA0B,EAAE,gBAAgB;EAC5C,YAAY,EAAE,2CAA2C;AAC3D;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,gBAAgB,EAAE,iDAAiD;EACnE,gBAAgB,EAAE,8DAA8D;EAChF,UAAU,EAAE,uCAAuC;EACnD,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,gBAAgB,EAAE,iDAAiD;EACnE,gBAAgB,EAAE,8DAA8D;EAChF,UAAU,EAAE,uCAAuC;EACnD,gBAAgB,EAAE,sBAAsB;EACxC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B,EAAE,iCAAiC;AAClE;;AAEA;EACE,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,0CAA0C;EAC1C,YAAY;EACZ,SAAS;AACX;;;AAGA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,0CAAkC;UAAlC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa,EAAE,wCAAwC;EACvD,mBAAmB;EACnB,YAAY;;EAEZ;IACE,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2BAA2B;EAC3B,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,0BAA0B,EAAE,qCAAqC;AACnE;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,0CAAkC;UAAlC,kCAAkC;EAClC,6BAA6B;;EAE7B;IACE,mBAAmB;EACrB;AACF;;AAEA;;GAEG;CACF;EACC,aAAa;CACd;;CAEA;EACC,aAAa;EACb,eAAe;CAChB;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0CAAkC;UAAlC,kCAAkC;EAClC,6BAA6B;AAC/B;;;AAGA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,YAAY;IACZ,SAAS;EACX;;EAEA;;KAEG;AACL;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;;;AAG3B;;;;AAIA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,gBAAgB,EAAE,mCAAmC;EACrD,gCAAgC;EAChC,eAAe;EACf,MAAM;EACN,WAAW;EACX,wCAAwC;EACxC,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB,EAAE,uCAAuC;EAC9D,UAAU,EAAE,2BAA2B;EACvC,SAAS,EAAE,0BAA0B;EACrC,aAAa,EAAE,2BAA2B;EAC1C,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,SAAO,EAAE,6BAA6B;EACtC,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,cAAc,EAAE,wCAAwC;EACxD,YAAY,EAAE,eAAe;EAC7B,kBAAkB,EAAE,sBAAsB;EAC1C,oBAAoB,EAAE,4BAA4B;EAClD,qBAAqB,EAAE,gCAAgC;EACvD,gBAAgB,EAAE,yBAAyB;EAC3C,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,sBAAsB,EAAE,8BAA8B;EACtD,YAAY,EAAE,wBAAwB;AACxC;;AAEA;EACE,aAAa,EAAE,2BAA2B;EAC1C,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,yBAAyB,EAAE,2CAA2C;AACxE;;AAEA,0DAA0D;AAC1D;EACE;IACE,gBAAgB,EAAE,uDAAuD;EAC3E;AACF;;AAEA;EACE;IACE,gBAAgB,EAAE,+CAA+C;EACnE;AACF;;AAEA;EACE;IACE,gBAAgB,EAAE,0DAA0D;EAC9E;AACF;;;AAGA;EACE,kBAAkB,EAAE,oEAAoE;AAC1F;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,yBAAyB;EACpC,SAAS,EAAE,8CAA8C;EACzD,2BAA2B,EAAE,+CAA+C;EAC5E,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,WAAW,EAAE,6BAA6B;EAC1C,gBAAgB,EAAE,mDAAmD;EACrE,eAAe,EAAE,8CAA8C;EAC/D,gBAAgB,EAAE,oCAAoC;EACtD,gBAAgB,EAAE,+BAA+B;EACjD,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,yBAAyB;EAChE,SAAS,EAAE,6BAA6B;AAC1C;;AAEA;EACE,eAAe;EACf,aAAa,EAAE,2CAA2C;EAC1D,mBAAmB,EAAE,4CAA4C;AACnE;;AAEA;EACE,gBAAgB,EAAE,iDAAiD;EACnE,cAAc,EAAE,gDAAgD;EAChE,iBAAiB,EAAE,sBAAsB;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iBAAiB;;EAEjB;IACE;0BACsB;IACtB,yBAAyB;IACzB,UAAU,EAAE,+BAA+B;EAC7C;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;AAC5C;;;;AAIA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,iCAAiC;EACjE,mBAAmB;EACnB,YAAY;EACZ,SAAS,EAAE,wBAAwB;EACnC,eAAe,EAAE,mDAAmD;EACpE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,SAAO,EAAE,uCAAuC;EAChD,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc,EAAE,sCAAsC;AACxD;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB,EAAE,2BAA2B;IACnD,uBAAuB,EAAE,4BAA4B;EACvD;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB,EAAE,oCAAoC;IACxD,kBAAkB,EAAE,yCAAyC;EAC/D;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,wCAAwC;IACxC,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;;EAEd;IACE,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;;EAElB;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["\n.home-page {\n  padding-top: 3rem;\n  text-align: center;\n\n  button {\n    margin-top: 1vh;\n    color: white;\n    background-color: #0091ea;\n    padding: 2%;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-shadow: 1px 1px 2px black;\n    border: 1px solid #0091ea;\n  }\n  \n  button:hover {\n    background-color: #00aff0;\n  }\n}\n\n.get-started-automating {\n  padding-top: 2vh;\n  padding-bottom: 5vh;\n}\n\n.contact-container {\n  display: flex;\n  padding-top: 3vh;\n  justify-content: center;\n}\n\n.contact-form {\n  background-color: white;\n  padding: 2vw;\n  width:100%;\n  margin-top: 10vh;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n  h1 {\n    font-size: 2rem;\n  }\n\n  label {\n    font-size: 1rem;\n  }\n  button {\n    color: white;\n    background-color: #0091ea;\n    padding: 2%;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-shadow: 1px 1px 2px black;\n    border: 1px solid #0091ea;\n  }\n\n  input {\n    border-radius: 10px;\n    padding: 1%;\n    margin: 2%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border: 1px solid #0091ea;\n    width: 70%;\n  }\n\n  input:focus {\n    outline: none !important;\n  }\n\n  textarea {\n    border-radius: 10px;\n    padding: 1%;\n    margin: 2%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border: 1px solid #0091ea;\n    width: 70%;\n  }\n\n  textarea:focus {\n    outline: none !important;\n  }\n\n  \n}\n\n.about-page {\n  padding-top: 3rem;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  height: auto;\n} \n\n.about-page-header {\n  flex: 2;\n}\n\n.whoweare-image-container {\n  width: 100%;\n  height: auto;\n}\n\n.whoweare-text {\n  bottom: 0;\n  color: #00aff0;\n  background-image: url('logolarge.png');\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  h1 {\n    color: grey;\n    text-align: left;\n    text-decoration: underline;\n    text-decoration-color: #00aff0;\n    font-size: 2rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  p {\n    color: black;\n    font-size: 2rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n.about-page-second-box {\n  display: flex;\n  flex-direction: column;\n}\n\n.about-page-second-box-box {\n  padding-top: 6rem;\n  padding-bottom: 6rem;\n  padding-left: 20vw;\n  background-color: #00aff0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n  h1 {\n    color: white;\n    text-align: left;\n    text-decoration: underline;\n    text-underline-offset: 3%;\n    text-decoration-color: white;\n    font-size: 2rem;\n    margin: 1rem;\n  }\n\n  p {\n    color: white;\n    font-size: 1.5rem;\n    margin: 1rem;\n  }\n\n  button {\n    border: none;\n    padding: 1rem;\n    margin-right: 6rem;\n    margin-bottom: 2rem;\n    border-radius: 1rem;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin: 1rem;\n  }\n\n  button:hover {\n    color: #00aff0;\n  }\n}\n\n.about-page-second-second-box {\n  padding-top: 6rem;\n  padding-bottom: 6rem;\n  padding-right: 20vw;\n  background-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: right;\n  \n  h1 {\n    color: grey;\n    text-align: right;\n    text-decoration: underline;\n    text-underline-offset: 3%;\n    text-decoration-color: #00aff0;\n    font-size: 2rem;\n  }\n\n  p {\n    color: black;\n    font-size: 1.5rem\n  }\n\n  button {\n    border: none;\n    padding: 1rem;\n    margin-left: 6rem;\n    margin-bottom: 2rem;\n    border-radius: 1rem;\n    background-color: #00aff0;\n    color: white;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n  button:hover {\n    background-color: #0091ea;\n  }\n}\n\n.about-page-twotonebox-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.about-page-users-box-light-blue {\n  width: 20vw;\n  height: 40vh;\n  background-color: #a7e7ff;\n\n}\n\n.about-page-users-box-dark-blue {\n  width: 80vw;\n  height: 45vh;\n  background-color: #00aff0;\n\n  h1 {\n    color: white;\n    text-align: left;\n    text-decoration: underline;\n    text-underline-offset: 3%;\n    text-decoration-color: white;\n    font-size: 2vw;\n    padding-left: 5rem;\n  }\n\n  p {\n    color: white;\n    font-size: 1vw;\n    padding-left: 5rem;\n  }\n}\n\n.about-page-white-box {\n  height: 10vh;\n}\n\n.about-page-white-box-users {\n  height: 33vh;\n}\n\n.userbox {\n  position: relative;\n  width: 100%;\n}\n\n\n\n.about-page-support-twotonebox-container {\n  display: flex;\n  flex-direction: row;\n  height: auto;\n}\n\n.about-page-users-support-box-light-blue {\n  width: 85vw;\n  height: auto;\n  background-color: #a7e7ff;\n \n  h1 {\n    margin-top: 5%;\n    color: grey;\n    text-align: left;\n    text-decoration: underline;\n    text-underline-offset: 3%;\n    text-decoration-color: #00aff0;\n    font-size: 2rem;\n    padding-left: 5rem;\n    margin-right: 1rem;\n    margin-left: 1rem;\n  }\n\n  p {\n    color: black;\n    font-size: 1.5rem;\n    padding-left: 5rem;\n    margin-right: 1rem;\n    margin-left: 1rem;\n  }\n\n  button {\n    color: black;\n    background-color: white;\n    padding: 1rem;\n    margin-left: 6rem;\n    margin-bottom: 2rem;\n    border-radius: 1rem;\n    border: none;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  button:hover {\n    color: #00aff0;\n  }\n}\n\n.about-page-users-support-box-dark-blue {\n  width: 15vw;\n  height: auto;\n  background-color: #00aff0;\n}\n\n.about-page-pb-parent{\n  display: flex;\n  /* justify-content: space-between; */\n  height: 15vh;\n  width: 100%;\n}\n\n.about-page-post-boxes {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  gap: 3vw;\n  \n  position: absolute;\n  top: 16vh; \n  left: 30vh;  \n  padding: 0 auto;\n  transform: translate(0%, 1%);\n  color: #00aff0; \n}\n\n.about-page-post-box {\n  flex: 3;\n  width: 20vw;\n  height: 10vh;\n}\n\n.login-register-anchor {\n  a {\n    color: white;\n  }\n\n  a:hover {\n    color:#0091ea\n  }\n}\n\n.registration-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background-color: white;\n}\n\n.footer-container {\n  padding-top: 3vh;\n  display: flex;\n  flex-direction: row;\n  gap: 2%;\n  background-color: #00aff0;\n  overflow: hidden;\n  width: 100%;\n  box-shadow: 0 4px 8px black;\n  border-top: 1vh solid white;\n  height: 3rem;\n  z-index: 1000;\n  padding-left: 4vw;\n}\n\n.pp-title-container {\n  padding-top: 4%;\n  background-color: white;\n  height: 10%;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.pp-title-container h1 {\n  padding-top: 1vh;\n  padding-left: 30vw;\n}\n\n.pp-tos-container {\n  background-color: white;\n  height: 10%;\n}\n\n.pp-tos-container h1 {\n  padding-left: 30vw;\n  text-align: left;\n}\n\n.missionHeader {\n  padding-top: 5vh;\n  padding-bottom: 1vh;\n  text-decoration: underline;\n}\n\n.constact-support-container {\n  padding-top: 3vh;\n  display: flex;\n  flex-direction: row;\n  font-family: Arial, sans-serif;\n  color: #333;\n  height: 100%;\n}\n\n\n.pp-policy-container {\n  padding-top: 3vh;\n  display: flex;\n  flex-direction: row;\n  font-family: Arial, sans-serif;\n  color: #333;\n  height: auto; /* Adjust height to auto so it expands based on content */\n}\n\n.pp-policy-container2 {\n  border-top: 1px solid white;\n  display: flex;\n  flex-direction: row;\n  font-family: Arial, sans-serif;\n  color: #333;\n  height: auto; /* Adjust height to auto so it expands based on content */\n}\n\n.contact-support-left {\n  background-color: #00aff0;\n  width: 15vw;\n  height: 100vh; /* Ensures the left panel is at least as tall as the viewport */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.contact-support-right {\n  background-color: #0091ea;\n  width: 85vw;\n  padding-left: 10vw;\n  padding-right: 10vw;\n  height: 100vh; /* Ensures the right panel is at least as tall as the viewport */\n  box-sizing: border-box;\n}\n\n.pp-policy-container-left {\n  background-color: #00aff0;\n  width: 15vw;\n  min-height: 100vh; /* Ensures the left panel is at least as tall as the viewport */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding-top: 4vh;\n}\n\n.pp-policy-container-right {\n  background-color: #0091ea;\n  width: 85vw;\n  padding-left: 10vw;\n  padding-top: 4vh;\n  padding-right: 10vw;\n  padding-bottom: 4vh; \n  min-height: 100vh; /* Ensures the right panel is at least as tall as the viewport */\n  box-sizing: border-box;\n}\n\n.privacy-policy-text-container {\n  color: white; /* Adjust text color to ensure readability */\n  line-height: 1.6; /* Improve text readability */\n}\n\n.policy-heading {\n  font-size: 1.5rem;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  color: white;\n}\n\n.policy-subheading {\n  font-size: 1.25rem;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  color: white;\n}\n\n.policy-text {\n  font-size: 1rem;\n  margin-bottom: 10px;\n  text-align: justify;\n  color: white;\n}\n\n\n.registration-box {\n  width: 90%;\n  max-width: 400px;\n  padding: 3rem;\n  background-color: #00aff0;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  color: white;\n  margin: 1rem;\n  h1 {\n    text-shadow: 1px 1px 2px black;\n  }\n\n  button {\n    margin-top: 10%;\n    color: white;\n    background-color: #0091ea;\n    padding: 2%;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-shadow: 1px 1px 2px black;\n    border: 1px solid #0091ea;\n  }\n}\n\n.registration-input-container {\n  input {\n    border-radius: 10px;\n    padding: 4%;\n    margin: 2%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border: 1px solid #0091ea;\n  }\n\n  input:focus {\n    outline: none !important;\n  }\n}\n\n.login-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background-color: white;\n}\n\n.login-box {\n  width: 90%;\n  max-width: 400px;\n  padding: 3rem;\n  background-color: #00aff0;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  color: white;\n  margin: 1rem;\n  h1 {\n    text-shadow: 1px 1px 2px black;\n  }\n\n  button {\n    margin-top: 10%;\n    color: white;\n    background-color: #0091ea;\n    padding: 2%;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-shadow: 1px 1px 2px black;\n    border: 1px solid #0091ea;\n  }\n}\n\n.login-input-container {\n  input {\n    border-radius: 10px;\n    padding: 4%;\n    margin: 2%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border: 1px solid #0091ea;\n  }\n\n  input:focus {\n    outline: none !important;\n  }\n}\n\n.App-logo {\n  max-height: 20vmin;\n  pointer-events: none;\n}\n\n/* @media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: combinedAnimation 5s linear infinite;\n  }\n} */\n\n.App-logo {\n  border-radius: 5%;\n  box-shadow: 5px 5px black;\n}\n\n@keyframes combinedAnimation {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(1.2);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n\n.Login-header {\n  background-color: #282c34;\n  min-height: 25vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n  padding: 4%;\n}\n\n.App-header {\n  background-color: #00aff0;\n  min-height: 20vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2vw;\n  color: white;\n  padding-top: 2%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  \n  h2 {  \n    text-shadow: 1px 1px 2px black;\n  }\n}\n\n.home-page-body {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 1rem;\n  text-align: center;\n  padding-bottom: 2vh;\n  p {\n    font-size: 1.5rem;\n  }\n}\n\n.schedule-job-header {\n  background-color: #282c34;\n  min-height: 15;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n  padding-top: 6rem;\n}\n\n.who-this-is-for-container {\n  text-align: left;\n  margin: 3%;\n}\n\n.two-tone-feature-container {\n  display: flex;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n\n.small-feature-darkblue {\n  background-color: #0091ea;\n  height: auto;\n  width: 15vw;\n  padding-bottom: 2vh;\n}\n\n.big-feature-blue {\n  background-color: #00aff0;\n  /* height: auto; */\n  height: 40vh;\n  width: 85vw;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: left; */\n  vertical-align: middle;\n  align-items: center;\n  /* text-align: left; */\n\n  h1 {\n    margin-left: 3vw;\n    color: white;\n    font-size: 2rem;\n    margin-right: 3vw;\n  }\n  \n  p {\n    margin-left: 3vw;\n    color: white;\n    font-size: 1.75rem;\n    margin-right: 3vw;\n  }\n  padding-bottom: 2vh;\n}\n\n\n.big-feature-darkblue {\n  background-color: #0091ea;\n  /* height: auto; */\n  height: 35vh;\n  width: 85vw;\n  display: flex;\n  \n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  h1 {\n    margin-right: 3vw;\n    color: white;\n    font-size: 2rem;\n    margin-left: 3vw;\n  }\n\n  p {\n    color: white;\n    margin-right: 3vw;\n    font-size: 1rem;\n    margin-left: 3vw;\n  }\n\n  padding-bottom: 2vh;\n}\n\n.tos-priv-homescreen {\n  margin-top: 3rem;\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.small-feature-blue {\n  background-color: #00aff0;\n  height: auto;\n  width: 15vw;\n}\n\n.features-white-box {\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #0091ea;\n  display: flex;\n  flex-direction: column;\n\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n\n  h1 {\n    font-size: 2rem;\n  }\n\n  p {\n    font-size: 1.75rem;\n    padding-left: 2vw;\n    padding-right: 2vw;\n  }\n\n  /* padding-bottom: 2vh; */\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes scaleAnimation {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.2);\n  }\n}\n\n\n/* CSS styles */\n.modal-container {\n  position: relative;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  backdrop-filter: blur(5px); /* Blur effect */\n  z-index: 999; /* Ensure backdrop is above other content */\n}\n\n/* Style the modal */\n.UpdateImageDataModal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  z-index: 1000;\n  box-shadow: 0 0 10px #00aff0;\n  max-height: 75vh; /* Set maximum height to 75% of viewport height */\n  overflow-y: auto; /* Enable vertical scrolling when content exceeds max-height */\n  width: 75%; /* Set width to 75% of viewport width */\n  max-width: 500px; /* Set maximum width */\n}\n\n.jobsdetailsmodal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  z-index: 1000;\n  box-shadow: 0 0 10px #00aff0;\n  max-height: 75vh; /* Set maximum height to 75% of viewport height */\n  overflow-y: auto; /* Enable vertical scrolling when content exceeds max-height */\n  width: 75%; /* Set width to 75% of viewport width */\n  max-width: 500px; /* Set maximum width */\n  text-align: center;\n}\n\n.image-box {\n  /* Add other styles */\n  border: 1px solid transparent; /* Initially set to transparent */\n}\n\n.image-box.selected {\n  border-color: lightgrey; /* Change border color when selected */\n}\n\n.image-name {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.7);\n  padding: 5px;\n  margin: 0;\n}\n\n\n.upload-box-container {\n  /* margin-top: 3px; */\n  /* border: 2px solid #ccc; */\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #282c34;\n  color: white;\n  padding-top: 4rem;\n}\n\n.upload-picture-box {\n  background-color: #282c34;\n  color: white;\n  padding-bottom: 1rem;\n}\n\n.upload-section {\n  padding: 10px;\n}\n\n.upload-section label {\n  margin-right: 10px;\n  text-decoration-color: white;\n}\n\n.upload-section button {\n  margin-top: 10px;\n  text-decoration-color: white;\n}\n\n.upload-color {\n  color: white;\n  text-align: center;\n  background-color: #282c34;\n}\n\n.dmjob-modal-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-width: 50%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-y: scroll;\n}\n\n.dmjobModal {\n  height: 60vh;\n  margin-top: 2rem;\n  background-color: white;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 0 10px #00aff0;\n  z-index: 1000;\n  align-items: center;\n  margin: 1rem;\n  overflow-y: scroll;\n  min-width: 90vw;\n}\n\n/* CSS styles for SetScheduleModal */\n.SetScheduleModal-modal-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-width: 70%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-y: scroll;\n}\n\n.SetScheduleModal-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.setScheduleModalHeader {\n  text-decoration: underline #00aff0;\n  text-underline-offset: .5rem;\n}\n\n.SetScheduleModal {\n  height: 60vh;\n  margin-top: 2rem;\n  background-color: white;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 0 10px #00aff0;\n  z-index: 1000;\n  align-items: center;\n  margin: 1rem;\n  overflow-y: scroll;\n  min-width: 90vw;\n}\n\n.postJobModal {\n  height: 60vh;\n  min-width: 90vw;\n  margin-top: 2rem;\n  background-color: white;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 0 10px #00aff0;\n  z-index: 1000;\n  align-items: center;\n  margin: 1rem;\n  overflow-y: scroll;\n}\n\n.loginmodal {\n  background-color: white;\n  padding: 3rem;\n  border-radius: 1rem;\n  box-shadow: 0 0 10px #00aff0;\n  z-index: 1000; /* Ensure modal appears above backdrop */\n  align-items: center;\n  margin: 1rem;\n\n  button {\n    /* margin-left: 1rem; */\n    padding: 1rem;\n    background-color: #0091ea;\n    border-radius: 1rem;\n    border: 0;\n    color: white;\n  }\n\n  button:hover {\n    background-color: #00aff0;\n  }\n}\n\n.selected-day {\n  background-color: lightgrey;\n  color: black; /* Adjust text color as needed */\n}\n\n.selected-day:hover {\n  background-color: darkgrey; /* Change color on hover if desired */\n}\n\n.aiInputs {\n  margin: 1rem;\n  font-size: 1.25rem;\n  text-decoration: underline #00aff0;\n  text-underline-offset: .25rem;\n  \n  label {\n    margin-bottom: 1rem;\n  }\n}\n\n/* .aibox {\n  margin-top: 1rem;\n} */\n .ailabel {\n  display: flex;\n }\n\n .aitext {\n  display: flex;\n  flex-wrap: wrap;\n }\n\n.aiInputContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modalSelect {\n  padding: .5rem;;\n  margin: .5rem;\n  border-radius: 1rem;\n  background-color: #00aff0;\n  color: white;\n  border: 0;\n}\n\n.modalSelect:hover {\n  padding: .5rem;;\n  margin: .5rem;\n  border-radius: 1rem;\n  background-color: #0091ea;\n  color: white;\n  border: 0;\n}\n\n.disabledButton {\n  cursor: not-allowed;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.input-group {\n  font-size: 1.25rem;\n  text-decoration: underline #00aff0;\n  text-underline-offset: .25rem;\n}\n\n\n/* This is for the time selectors */\n.input-group > div {\n  display: flex;\n  justify-content: center; \n  align-items: center; \n  gap: 10px;\n}\n\n.dayselect-input {\n  \n  button {\n    margin: 1rem;\n    padding: 1rem;\n    border: none;\n    border-radius: 1rem;\n    cursor: pointer;\n    /* background-color: #00aff0; */\n    text-align: center; \n    color: white;\n    border: 0;\n  }\n\n  /* button:hover {\n    background-color: red;\n  } */\n}\n\n/* Style for the button */\n.input-group button {\n  margin: 1rem;\n  padding: 1rem;\n  border: none;\n  border-radius: 1rem;\n  cursor: pointer;\n  background-color: #00aff0; \n  text-align: center; \n  color: white;\n  border: 0;\n}\n\n.subredditSelect button {\n  margin: 1rem;\n  padding: 1rem;\n  border: none;\n  border-radius: 1rem;\n  cursor: pointer;\n  background-color: #00aff0; \n  text-align: center; \n  color: white;\n  border: 0;\n}\n\n.input-group button:hover {\n  margin: 1rem;\n  padding: 1rem;\n  border: none;\n  border-radius: 1rem;\n  cursor: pointer;\n  background-color: #0091ea; \n  text-align: center; \n  color: white;\n  border: 0;\n}\n\n.unselected-day {\n  background-color: #00aff0; \n  /* color: #ffffff;  */\n}\n\n.selected-day {\n  background-color: #146aa0; \n  \n \n}\n\n\n\n.navbar {\n  background-color: #00aff0; /* Background color of the navbar */\n  overflow: hidden; /* Ensure contents don't overflow */\n  border-bottom: 2px solid #0091ea;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-shadow: 1px 1px 2px black;\n  height: 3rem;\n  z-index: 1000;\n  display: flex;\n  justify-content: space-between;\n}\n\n.navbar ul {\n  list-style-type: none; /* Remove bullet points from the list */\n  padding: 0; /* Remove default padding */\n  margin: 0; /* Remove default margin */\n  display: flex; /* Use flexbox for layout */\n  align-items: center; /* Center items vertically */\n}\n\n.navbar li {\n  flex: 1; /* Make list items flexible */\n  text-align: center; /* Center-align text */\n}\n\n.navbar li a {\n  display: block; /* Display the links as block elements */\n  color: white; /* Text color */\n  text-align: center; /* Center-align text */\n  padding: 0.5rem 1rem; /* Padding around the text */\n  text-decoration: none; /* Remove underline from links */\n  font-size: 1.2vw; /* Responsive font size */\n  white-space: nowrap; /* Prevent text wrapping */\n}\n\n.navbar li a:hover {\n  background-color: #ddd; /* Background color on hover */\n  color: black; /* Text color on hover */\n}\n\n.left-section, .right-section {\n  display: flex; /* Use flexbox for layout */\n  align-items: center; /* Center items vertically */\n}\n\n.right-section {\n  justify-content: flex-end; /* Align right-section items to the right */\n}\n\n/* Media queries to adjust font-size for smaller screens */\n@media (max-width: 1024px) {\n  .navbar li a {\n    font-size: 1.4vw; /* Slightly increase the font size for medium screens */\n  }\n}\n\n@media (max-width: 768px) {\n  .navbar li a {\n    font-size: 1.6vw; /* Increase the font size for smaller screens */\n  }\n}\n\n@media (max-width: 480px) {\n  .navbar li a {\n    font-size: 2.5vw; /* Further increase the font size for very small screens */\n  }\n}\n\n\n.subreddit-selector {\n  position: relative; /* Needed to position the dropdown absolutely within the container */\n}\n\n.subreddit-selector .dropdown-menu {\n  position: absolute;\n  left: 50%; /* Centers the dropdown */\n  top: 100%; /* Moves the dropdown right below the button */\n  transform: translateX(-50%); /* Shifts the dropdown back by half its width */\n  background-color: white;\n  border: 1px solid #ccc;\n  box-shadow: 0 8px 16px rgba(0,0,0,0.2);\n  width: auto; /* Adjusts width to content */\n  min-width: 300px; /* Minimum width, adjust based on your preference */\n  max-width: 90vw; /* Prevents the dropdown from being too wide */\n  max-height: 15vh; /* Adjust based on your preference */\n  overflow-y: auto; /* Enables vertical scrolling */\n  z-index: 1;\n}\n\n.subreddit-selector .dropdown-menu .grid-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr); /* Creates four columns */\n  gap: 10px; /* Space between grid items */\n}\n\n.subreddit-selector .dropdown-menu .grid-item label {\n  cursor: pointer;\n  display: flex; /* Ensures the label contents are in line */\n  align-items: center; /* Aligns the checkbox and text vertically */\n}\n\n.subreddit-selector .dropdown-menu .grid-item label span {\n  margin-left: 5px; /* Provides space between the checkbox and text */\n  display: block; /* Allows text to use the full available space */\n  overflow: visible; /* Shows all content */\n}\n\n.jobs-table {\n  display: flex;\n  justify-content: center;\n  height: auto; \n  margin-top: 5%;\n  margin-bottom: 5%;\n\n  table {\n    /* padding-left: 2rem;\n    padding-right: 2rem; */\n    border-collapse: collapse;\n    width: 50%; /* Adjust the width as needed */\n  }\n  \n  th, td {\n    border: 1px solid #ddd;\n    padding: 1rem;\n    text-align: left;\n  }\n  \n  th {\n    background-color: #f2f2f2;\n    font-weight: bold;\n  }\n  \n  tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  tr:hover {\n    background-color: #ddd;\n  }\n}\n\n.jobs-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.jobs-header-container {\n  padding-top: 10vh;\n  text-align: center;\n\n}\n\n.active-job-box {\n  background-color: #0091ea;\n  margin: 0 2rem 1rem;\n  padding: 0.5rem;\n  min-height: 4rem;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.1);\n}\n\n\n\n.active-job-box:hover {\n  background-color: #00aff0;\n}\n\n.job-details {\n  display: flex;\n  justify-content: space-between; /* Spread items across the line */\n  align-items: center; \n  height: 100%;\n  gap: 1rem; /* Space between items */\n  flex-wrap: wrap; /* Allow wrapping to new lines on smaller screens */\n  padding: 1rem;\n}\n\n.job-details p {\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.2;\n  word-wrap: break-word;\n  flex: 1; /* Allow text to take available space */\n  color: white;\n}\n\n.canceljobbuttonbox button {\n  font-size: 1rem;\n  padding: 0.4rem 0.8rem;\n  border: none;\n  background-color: #ff3b30;\n  color: white;\n  cursor: pointer;\n  border-radius: 0.3rem;\n  flex-shrink: 0; /* Prevent the button from shrinking */\n}\n\n.canceljobbuttonbox {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Adjust for smaller screens */\n@media (max-width: 768px) {\n  .active-job-box {\n    margin: 0 1rem 1rem;\n    padding: 0.8rem;\n  }\n\n  .job-details {\n    flex-direction: column; /* Stack items vertically */\n    align-items: flex-start; /* Align items to the left */\n  }\n\n  .job-details p,\n  .job-details button {\n    font-size: 0.9rem;\n  }\n\n  .job-details button {\n    margin-top: 0.5rem; /* Add some space above the button */\n    align-self: center; /* Center the button on smaller screens */\n  }\n}\n\n@media (max-width: 480px) {\n  .active-job-box {\n    margin: 0 0.5rem 1rem;\n    padding: 1rem;\n  }\n\n  .job-details p,\n  .job-details button {\n    font-size: 0.85rem;\n  }\n\n  .job-details button {\n    padding: 0.3rem 0.7rem;\n  }\n}\n\n.active-jobs-container {\n  padding: 1rem 0;\n}\n\n\n.photo-post-job-container {\n  p{\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n\n.jobbox {\n  margin-bottom: 3rem;\n  text-align: center;\n  \n  p{\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  button {\n    color: white;\n    background-color: #0091ea;\n    border: 0;\n    border-radius: 1rem;\n    padding: 1rem;\n    margin-top: .25rem;\n  }\n\n  button:hover {\n    background-color: #00aff0;\n  }\n\n}\n\n.updateImageModalButtons {\n  button {\n    margin-top: 1vh;\n    color: white;\n    background-color: #0091ea;\n    padding: 2%;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-shadow: 1px 1px 2px black;\n    border: 1px solid #0091ea;\n    margin: 1rem;\n  }\n  \n  button:hover {\n    background-color: #00aff0;\n  }\n}\n\n\n.ReactTags__tagInputField {\n  width: 100%;\n  border-radius: 1rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  padding-left: .15rem;\n  border: 1px solid black;\n  margin-bottom: 1rem;\n}\n\n.ReactTags__remove {\n  background-color: #00aff0;\n  border: 0;\n  border-radius: 1rem;\n  text-align: center;\n  margin: .25rem;\n\n  svg {\n    display: block;\n    margin: auto;\n  }\n}\n\n.authorize-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  button {\n    margin-left: 1rem;\n    background-color: #0091ea;\n    border-radius: .25rem;\n    border: 0;\n    color: white;\n  }\n\n  button:hover {\n    background-color: #00aff0;\n  }\n}\n \n.authorized-accounts-box {\n  border: .25rem solid #00aff0;\n  height: 8.5rem;\n  margin: 1rem;\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  border-radius: 1rem;\n}\n\n.authorize-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.accountbox {\n  border: 1px solid black;\n  height: 4rem;\n  width: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  margin: 1rem;\n  border-radius: 1rem;\n  background-color: #0091ea;\n  border: 0;\n  color: white;\n}\n\n.accountbox:hover {\n  background-color: #00aff0;\n}\n\n.password-validations p {\n  margin: 0;\n  padding: 5px 0;\n  font-size: 14px;\n}\n\n.password-validations .valid {\n  color: green;\n}\n\n.password-validations .invalid {\n  color: red;\n}\n\n.login-error-message {\n  color: red;\n}\n\n.username-validations p {\n  margin: 0;\n  padding: 5px 0;\n  font-size: 14px;\n}\n\n.username-validations .valid {\n  color: green;\n}\n\n.username-validations .invalid {\n  color: red;\n}\n\n.registerbutton button:disabled {\n  background-color: grey;\n  cursor: not-allowed;\n}\n\n.payment-page-container {\n  display: flex;\n  justify-content: center; \n  align-items: center;   \n  height: 100vh;         \n}\n\n.payment-box {\n  display: flex;\n  justify-content: center; \n  align-items: center;   \n  width: 100%;            \n  height: 100%;           \n}\n\n.proSuccessContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  text-align: center;\n}\n\n.proSuccessScreen {\n  padding: 2rem;\n  color: #00aff0;\n  \n  a {\n    color: #0091ea;\n  }\n}\n\n.youHavePremium {\n  text-align: center;\n\n  button {\n    padding: 1rem;\n    background-color: #0091ea;\n    border-radius: 1rem;\n    border: 0;\n    color: white;\n  }\n\n  button:hover {\n    background-color: #00aff0;\n  }\n}\n\n.limitmodalLandingscreen {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
